<template>
    <div class="page-tools" v-if="isShow">
        <div class="page-tools__item hide-me--mobile" v-if="data.print">
            <a
                href="javascript: void(0);"
                @click="print()"
            >
                <z-icon
                    name="print"
                    width="24"
                    height="24"
                />
            </a>
        </div>
        <div class="page-tools__item" v-if="data.share">
            <tippy-component
                placement="right"
                :trigger="getEventForDevice"
                :interactive="true"
                theme="sharing"
            >
                <template v-slot:trigger>
                    <a href="javascript: void(0);">
                        <z-icon
                            name="share"
                            width="24"
                            height="24"
                        />
                    </a>
                </template>
                <z-share
                    bare
                    :lang="$root.lang"
                    :services="['vkontakte','odnoklassniki']"
                />
            </tippy-component>
        </div>
    </div>
</template>

<script>
import { TippyComponent } from 'vue-tippy'
import { localize } from '@/utils/i18n'
import { AppDeviceEnquire } from '@/utils/mixin'

export default {
    name: 'page-tools',
    components: {
        TippyComponent
    },
    mixins: [AppDeviceEnquire],
    data () {
        return {
            data: this.$root.app.components['aside'].tools,
            text: {
                share: localize({
                    'ru': 'Поделиться',
                    'en': 'Share'
                }),
                print: localize({
                    'ru': 'Распечатать',
                    'en': 'Print'
                })
            }
        }
    },
    computed: {
        getEventForDevice () {
            if (this.device === 'v-tablet' || this.device === 'mobile' || this.device === 'tablet') {
                return 'click'
            } else {
                return 'mouseenter focus'
            }
        },
        parent () {
            return this.$refs.pageToolsShare
        },
        isShow () {
            if (this.data) {
                for (let key in this.data) {
                    if (this.data[key]) {
                        return true
                    }
                }
            }

            return false
        }
    },
    methods: {
        print () {
            window.print()
        }
    }
}
</script>

<style lang="scss" src="./index.scss"></style>
